// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

// Load product page
/*
document.addEventListener('DOMContentLoaded', function() {

  const firstOption = document.querySelector('select[data-index="option1"]');
  const secondOption = document.querySelector('select[data-index="option2"]');
  const surfaceOptionWrapper = secondOption?.closest('.product__option');
  console.log('First option:', firstOption);
  console.log('Surface option wrapper:', surfaceOptionWrapper);

  if (firstOption && surfaceOptionWrapper) {
    console.log('Both options found');

    surfaceOptionWrapper.style.display = 'none';

    function toggleSurfaceOption() {
      console.log("sec-lenght: ", secondOption.options.length);
      if (firstOption.value !== '' && secondOption.options.length >= 3) {
        console.log('Showing Surface option');
        surfaceOptionWrapper.style.display = ''; 
        surfaceOptionWrapper.classList.add('active'); 
      } else {
        console.log('Hiding Surface option');
        surfaceOptionWrapper.style.display = 'none'; 
        surfaceOptionWrapper.classList.remove('active'); 
      }
    }

    firstOption.addEventListener('change', function() {
      console.log('First option changed. New value:', this.value);
      toggleSurfaceOption();
    });

    console.log('Checking initial state. First option value:', firstOption.value);
    toggleSurfaceOption();

  } else {
    console.log('One or both options not found');
  }
});
*/

// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  //console.log("Item added to the cart");
  //console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  //console.log("Cart updated");
  //console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  //console.log("Cart error");
  //console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  //console.log("Quick cart opened");
  //console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  //console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  //console.log("Product variant changed");
  //console.log(evt.detail.variant);
  
  const firstOption = document.querySelector('select[data-index="option1"]');
  const secondOption = document.querySelector('select[data-index="option2"]');
  const surfaceOptionWrapper = secondOption?.closest('.product__option');
  
  if (surfaceOptionWrapper) {
    //surfaceOptionWrapper.style.display = 'none';
    //blue-byte-boulevard-6
    //blue-byte-boulevard-5
    //morning-mist-2
    //binary-blueberry-5
    if (secondOption.value == "") {
      surfaceOptionWrapper.classList.remove('variant-hidden');
      const button = document.querySelector('button[data-add-to-cart]');
      button.setAttribute('disabled', 'disabled');
      button.querySelector('[data-add-to-cart-text]').innerText = 'Select '+secondOption.dataset.name+' to Add To Cart';
    }

    if (firstOption.value !== '') {
      if (secondOption && secondOption.value !== '') {
        document.querySelector('.inventory-counter')?.classList.remove('hidden');
      }  
    }
  } else {
    document.querySelector('.inventory-counter')?.classList.remove('hidden');
  }
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  //console.log("Product quantity updated");
  //console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  //console.log("Quick view loaded");

  //const firstOption = document.querySelector('.quick-product select[data-index="option1"]');
  //const secondOption = document.querySelector('.quick-product select[data-index="option2"]');
  //const surfaceOptionWrapper = secondOption?.closest('.product__option');
  //console.log('First option:', firstOption);
  //console.log('Surface option wrapper:', secondOption);

/*  
  if (firstOption && surfaceOptionWrapper) {
    surfaceOptionWrapper.style.display = 'none';   
    if (firstOption.value !== '' && secondOption.options.length >= 3) {
      surfaceOptionWrapper.style.display = '';
      surfaceOptionWrapper.classList.add('active');
    } else {
      surfaceOptionWrapper.style.display = 'none';
      surfaceOptionWrapper.classList.remove('active');
    }
  }
*/  
  let thumbnails = document.querySelectorAll(".quick-product__left .product-thumbnails__viewport .product-thumbnails__item");
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener("mouseover", function() {
      this.querySelector("button").click();
    });
  });  
  
});
/* eslint-enable no-console */

// Thumbnails activate on hover
document.addEventListener('DOMContentLoaded', function() {
    let thumbnails = document.querySelectorAll(".product-thumbnails__viewport .product-thumbnails__item");
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener("mouseover", function() {
        this.querySelector("button").click();
      });
    });

});




/*
document.addEventListener('DOMContentLoaded', function() {
      document.querySelector("[data-menu-button]").addEventListener("click", function(){
         const mobilMenuPanel = document.getElementById('mobil-menu');
         const mobilMenuParents = mobilMenuPanel.querySelectorAll('.mobile-menu__list--sub');
    
         if (mobilMenuParents[0]) {
            mobilMenuParents.forEach(mobilMenuParent => {          
              let height = mobilMenuParent.offsetHeight;
              mobilMenuParent.style.setProperty("--height", "".concat(height, "px"));
              mobilMenuParent.style.setProperty("max-height", "0");
            });
         }
      }); 
});
*/
//document.addEventListener('DOMContentLoaded', function() {
  // Step 1: Add event listener to the quick view button
//  const quickViewButtons = document.querySelectorAll('.product-item__quick-view-button.btn.btn--rounded.show-product-quick-view.product-item__disc-button');

//  quickViewButtons.forEach(button => {
//      button.addEventListener('click', function() {
//          console.log('Quick View button clicked.');

          // Step 2: Check and wait for the 'js-enabled product__option' class
//          const checkOptionClass = setInterval(() => {
//              const productOption = document.querySelector('.js-enabled.product__option');

//              if (productOption) {
//                  console.log('Product option element found.');

                  // Step 3: Check if any option from #option1[name="options[Size]"] is selected
//                  const sizeOptions = document.querySelector('#option1[name="options[Size]"]');

//                  if (sizeOptions) {
//                     sizeOptions.addEventListener('change', function() {
//                          console.log('Size option selected.');

                          // Step 4: Add 'active' class to the second child of .product__controls-group
//                          const secondOption = document.querySelector('.product__controls-group .product__option:nth-child(2)');
//                          if (secondOption) {
//                              secondOption.classList.add('active');
//                              console.log('Active class added to the second product option.');
//                          } else {
//                              console.log('Second product option not found.');
//                          }
//                      });
//                  } else {
//                     console.log('Size option element not found.');
//                  }

//                  clearInterval(checkOptionClass);
//              } else {
//                  console.log('Waiting for product option class to be added...');
//              }
//          }, 500); // Check every 500ms
//      });
//  });
//});
// end here







